import { useQuery, useMutation } from 'react-query';
import queryGetBeneficiaries from './query/getBeneficiaries';
import mutationUpdateBeneficiary from './mutations/updateBeneficiary';
import mutationCreateBeneficiary from './mutations/createBeneficiary';
import mutationDeleteBeneficiary from './mutations/deleteBeneficiary';

const actionsBeneficiaries = {
    // Getters
    getBeneficiaries: (params, enabled = true) => useQuery(queryGetBeneficiaries(params, enabled)),

    // Mutations
    createBeneficiary: (onSuccess, onError) => useMutation(mutationCreateBeneficiary(onSuccess, onError)),
    updateBeneficiary: (onSuccess, onError) => useMutation(mutationUpdateBeneficiary(onSuccess, onError)),
    deleteBeneficiary: (onSuccess, onError) => useMutation(mutationDeleteBeneficiary(onSuccess, onError))
};

export default actionsBeneficiaries;
